export default __webpack_public_path__ + "static/media/IBimageMobilityHip.74a268fa.png";